import React from 'react';

export default function PaymentGateway() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Payment Gateway</h1>
      <p className="text-gray-500">Halaman Payment Gateway</p>
    </div>
  );
}
